import { AnimatePresence, AnimateSharedLayout } from 'framer-motion';
import React, { useEffect } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import { Error } from '~/Components';
import { BOX_SHADOW } from '~/Constants/CSS.constants';
import { Route as RouteNeo } from '~/Constants/Routes.constants';
import { useLocalStorage, useNavigation } from '~/Hooks';
import { Drawer, useDrawer } from '~/Screens/Drawer';
import { OrganisationContainer, OrganisationSettings } from '~/ScreensOrganisation';
import { StaffEdit, StaffPage } from '~/ScreensOrganisation/OrganisationStaff';
import { StudioCreation, StudioPage } from '~/ScreensOrganisation/OrganisationStudio';
import { JumpingLoader } from '~/UIKit';
import { makeStyles } from '~/UIKit/Style';
import { useOrganisationRoutes } from './useOrganisationRoutes';
import { OrganisationMerchant } from '~/ScreensOrganisation/OrganisationMerchant';
import { MerchantBanner } from '~/ScreensOrganisation/OrganisationMerchant/HelperMerchant/MerchantBanner';
import { Header } from '~/Screens/Drawer/Header';

const {
  LOGIN,
  LOGIN_USC,
  ORGANISATION_ROOT,
  ORGANISATION_SELECT,
  PROVIDER_ROOT,
  ORGANISATION_SETTINGS,
  ORGANISATION_DETAIL,
  ORGANISATION_STAFF_CREATE,
  ORGANISATION_STUDIO,
  ORGANISATION_STUDIO_CREATE,
  ORGANISATION_STAFF,
  ORGANISATION_MERCHANT,
} = RouteNeo;

const useStyles = makeStyles({
  appRootWrapper: {
    margin: 0,
    boxShadow: BOX_SHADOW,
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
});

export const OrganisationRoutes = () => {
  // hooks
  const loc = useLocation();
  const { navigate } = useNavigation();
  const { classes } = useStyles();

  // state
  const { logout } = useLocalStorage();
  const {
    isLoggedIn,
    isNoOrganisationSelected,
    logOutURL,
    hasUserLoaded,
    userError,
    goBackToSafety,
    shouldGoToTheDashboard,
    organisationLoadError,
    hasRolesLoaded,
  } = useOrganisationRoutes();

  const { openDrawer, closeDrawer, mobileOpen } = useDrawer();

  // check general rerouting and access verification
  useEffect(() => {
    if (!isLoggedIn) {
      if (loc.pathname !== LOGIN && loc.pathname !== LOGIN_USC) {
        window.location.replace(logOutURL);
        logout();
      }
      return;
    }
    if (hasUserLoaded && hasRolesLoaded && organisationLoadError) {
      navigate(PROVIDER_ROOT);
      return;
    }
    if (!hasUserLoaded && location.pathname !== ORGANISATION_ROOT) {
      navigate(ORGANISATION_ROOT);
      return;
    }
    if (isNoOrganisationSelected) {
      if (loc.pathname !== ORGANISATION_SELECT) {
        navigate(ORGANISATION_SELECT);
      }
      return;
    }
    if (shouldGoToTheDashboard) {
      goBackToSafety();
      return;
    }
  }, [
    isLoggedIn,
    hasUserLoaded,
    isNoOrganisationSelected,
    shouldGoToTheDashboard,
    organisationLoadError,
    loc.pathname,
    hasRolesLoaded,
  ]);

  if (!isLoggedIn || !hasUserLoaded || !hasRolesLoaded) {
    return <JumpingLoader />;
  }

  const refreshPage = () => {
    window.location.reload();
  };

  return (
    <div className={classes.appRootWrapper}>
      <MerchantBanner />
      <Drawer isOpen={mobileOpen} onClose={closeDrawer} />
      <Header openDrawer={openDrawer} />
      <Error error={userError} errorAction={refreshPage} />
      <AnimateSharedLayout type="crossfade">
        <AnimatePresence initial={false}>
          <Switch>
            <Route component={OrganisationContainer} exact path={ORGANISATION_ROOT} />
            <Route component={StudioPage} exact path={ORGANISATION_DETAIL} />
            <Route component={StaffEdit} path={ORGANISATION_STAFF_CREATE} />
            <Route component={StudioPage} exact path={ORGANISATION_STUDIO} />
            <Route component={StudioCreation} exact path={ORGANISATION_STUDIO_CREATE} />
            <Route component={StaffPage} exact path={ORGANISATION_STAFF} />
            <Route component={OrganisationMerchant} path={ORGANISATION_MERCHANT} />
            <Route component={OrganisationSettings} exact path={ORGANISATION_SETTINGS} />
          </Switch>
        </AnimatePresence>
      </AnimateSharedLayout>
    </div>
  );
};
